<template>
  <v-expansion-panels multiple>
    <!-- -ข้อมูลทั่วไปผู้สมัคร -->
    <v-expansion-panel>
      <v-expansion-panel-header>
        ข้อมูลทั่วไปผู้สมัคร
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="nameSurname_eng"
          label="ชื่อ-สกุล (ภาษาอังกฤษ)"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="citizen_id"
          label="รหัสบัตรประชาชน/Passport"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="birthday"
          label="วันเกิด"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="nation"
          label="สัญชาติ"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="mobile"
          label="เบอร์โทร"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="email"
          label="EMAIL"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="project"
          label="โครงการ"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="address"
          label="ที่อยู่"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="notice"
          label="หมายเหตุ"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="order_1"
          label="สาขาที่เลือกอันดับ 1"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="order_2"
          label="สาขาที่เลือกอันดับ 2"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="order_3"
          label="สาขาที่เลือกอันดับ 3"
        ></v-checkbox>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- ระดับปริญญาตรี -->
    <v-expansion-panel>
      <v-expansion-panel-header>
        ข้อมูลประวัติโรงเรียน กรณีสมัครระดับปริญญาตรี
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="school_name"
          label="ชื่อโรงเรียน"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="school_type"
          label="ประเภทโรงเรียน"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="education_type"
          label="แผนการศึกษา"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="study_status"
          label="สถานภาพทางการศึกษา"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="study_type"
          label="ประเภทการศึกษา"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="term_of_gpa"
          label="จำนวนเทอมของ GPA"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="gpa"
          label="GPA"
        ></v-checkbox>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>
        ข้อมูลเพิ่มเติม
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="inter_info"
          label="ข้อมูลเพิ่มเติม (สำหรับนานาชาติ)"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="med_info"
          label="ข้อมูลเพิ่มเติม (สำหรับแพทย์)"
        ></v-checkbox>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- ระดับบัณฑิตศึกษา -->
    <v-expansion-panel>
      <v-expansion-panel-header>
        ข้อมูลประวัติการศึกษา กรณีสมัครระดับบัณฑิตศึกษา
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="undergraduate_info"
          label="ข้อมูลประวัติการศึกษาระดับปริญญาตรี"
        ></v-checkbox>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="master_info"
          label="ข้อมูลประวัติการศึกษาระดับปริญญาโท"
        ></v-checkbox>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- ข้อมูลประกอบหลักสูตรที่สมัคร -->
    <v-expansion-panel>
      <v-expansion-panel-header>
        ข้อมูลประกอบหลักสูตรที่สมัคร
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_2"
          label="GPA รวมทุกวิชา"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_3"
          label="GPA วิชาภาษาไทย"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_4"
          label="หน่วยกิต วิชาภาษาไทย"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_5"
          label="GPA วิชาคณิตศาสตร์"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_6"
          label="หน่วยกิต วิชาคณิตศาสตร์"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_7"
          label="GPA วิชาวิทยาศาสตร์"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_8"
          label="หน่วยกิต วิชาวิทยาศาสตร์"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_9"
          label="GPA วิชาฟิสิกส์"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_10"
          label="หน่วยกิต วิชาฟิสิกส์"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_11"
          label="GPA วิชาเคมี"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_12"
          label="หน่วยกิต วิชาเคมี"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_13"
          label="GPA วิชาชีววิทยา"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_14"
          label="หน่วยกิต วิชาชีววิทยา"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_15"
          label="GPA วิชาวิทยาศาสตร์ และ คณิตศาสตร์"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_16"
          label="หน่วยกิต วิชาวิทยาศาสตร์ และ คณิตศาสตร์"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_17"
          label="GPA วิชาภาษาอังกฤษ"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_18"
          label="หน่วยกิต วิชาภาษาอังกฤษ"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_20"
          label="GPA วิชาภาษาต่างประเทศ"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_21"
          label="หน่วยกิต วิชาภาษาต่างประเทศ"
        ></v-checkbox>

        <!-- ระดับบัณฑิตศึกษาจะใช้ -->

        <v-divider></v-divider>
        --- ข้อมูลสำหรับระดับบัณฑิตศึกษา

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_22"
          label="ชื่อมาตรฐานความรู้ภาษาอังกฤษ"
        ></v-checkbox>

        <v-checkbox
          hide-details
          class="mt-0"
          v-model="constarint_23"
          label="คะแนนสอบมาตรฐานความรู้ภาษาอังกฤษ"
        ></v-checkbox>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "SelectDataToShow",

  data: () => ({
    // ข้อมูลทั่วไปผู้สมัคร
    nameSurname_eng: null,
    citizen_id: null,
    birthday: null,
    nation: null,
    mobile: null,
    email: null,
    project: null,
    address: null,
    notice: null,
    order_1: null,
    order_2: null,
    order_3: null,

    // ข้อมูลประวัติโรงเรียน กรณีสมัครระดับปริญญาตรี
    school_name: null,
    school_type: null,
    education_type: null, //แผนการศึกษา
    study_status: null, //สถานภาพทางการศึกษา
    study_type: null, //ประเภทการศึกษา
    term_of_gpa: null,
    gpa: null,

    // ข้อมูลเพิ่มเติม
    inter_info: null, //สำหรับนานาชาติ
    med_info: null, //สำหรับแพทย์

    // ข้อมูลประวัติการศึกษา กรณีสมัครระดับบัณฑิตศึกษา
    undergraduate_info: null, //ระดับปริญญาตรี
    master_info: null, //ระดับปริญญาโท

    // ข้อมูลประกอบหลักสูตรที่สมัคร
    constarint_2: null, //GPA รวมทุกวิชา
    constarint_3: null, //GPA วิชาภาษาไทย
    constarint_4: null, //หน่วยกิต วิชาภาษาไทย
    constarint_5: null, //GPA วิชาคณิตศาสตร์
    constarint_6: null, //หน่วยกิต วิชาคณิตศาสตร์
    constarint_7: null, //GPA วิชาวิทยาศาสตร์
    constarint_8: null, //หน่วยกิต วิชาวิทยาศาสตร์
    constarint_9: null, //GPA วิชาฟิสิกส์
    constarint_10: null, //หน่วยกิต วิชาฟิสิกส์
    constarint_11: null, //GPA วิชาเคมี
    constarint_12: null, //หน่วยกิต วิชาเคมี
    constarint_13: null, //GPA วิชาชีววิทยา
    constarint_14: null, //หน่วยกิต วิชาชีววิทยา
    constarint_15: null, //GPA วิชาวิทยาศาสตร์ และ คณิตศาสตร์
    constarint_16: null, //หน่วยกิต วิชาวิทยาศาสตร์ และ คณิตศาสตร์
    constarint_17: null, //GPA วิชาภาษาอังกฤษ
    constarint_18: null, //หน่วยกิต วิชาภาษาอังกฤษ
    constarint_20: null, //GPA วิชาภาษาต่างประเทศ
    constarint_21: null, //หน่วยกิต วิชาภาษาต่างประเทศ
    constarint_22: null, //ชื่อมาตรฐานความรู้ภาษาอังกฤษ
    constarint_23: null, //คะแนนสอบมาตรฐานความรู้ภาษาอังกฤษ
  }),
  methods: {
    get_attribute() {
      return {
        nameSurname_eng: this.nameSurname_eng,
        citizen_id: this.citizen_id,
        birthday: this.birthday,
        nation: this.nation,
        mobile: this.mobile,
        email: this.email,
        project: this.project,
        address: this.address,
        notice: this.notice,
        order_1: this.order_1,
        order_2: this.order_2,
        order_3: this.order_3,
        school_name: this.school_name,
        school_type: this.school_type,
        education_type: this.education_type,
        study_status: this.study_status,
        study_type: this.study_type,
        term_of_gpa: this.term_of_gpa,
        gpa: this.gpa,
        inter_info: this.inter_info,
        med_info: this.med_info,
        undergraduate_info: this.undergraduate_info,
        master_info: this.master_info,
        constarint_2: this.constarint_2,
        constarint_3: this.constarint_3,
        constarint_4: this.constarint_4,
        constarint_5: this.constarint_5,
        constarint_6: this.constarint_6,
        constarint_7: this.constarint_7,
        constarint_8: this.constarint_8,
        constarint_9: this.constarint_9,
        constarint_10: this.constarint_10,
        constarint_11: this.constarint_11,
        constarint_12: this.constarint_12,
        constarint_13: this.constarint_13,
        constarint_14: this.constarint_14,
        constarint_15: this.constarint_15,
        constarint_16: this.constarint_16,
        constarint_17: this.constarint_17,
        constarint_18: this.constarint_18,
        constarint_20: this.constarint_20,
        constarint_21: this.constarint_21,
        constarint_22: this.constarint_22,
        constarint_23: this.constarint_23,
      };
    },
  },
};
</script>
